// 认证与账户词条：登录/验证码/密码/权限提示/表单校验（自 common.ts 权限杂烩按域迁出；
// 键位置对消费者不可见，按主要消费者归域）

export const zh = {
  permissionDenied: '权限不足',
  adminOnly: '该功能仅限管理员使用',
  welcomeBack: '欢迎回来',
  verifyIdentity: '验证身份',
  sendCode: '发送验证码',
  canceling: '取消中...',
  general: '综合',
  login: '登录',
  loginTabOtp: '验证码登录',
  passwordLoginTab: '密码登录',
  identifierLabel: '手机号 / 邮箱',
  identifierPlaceholder: '手机号或邮箱',
  passwordPlaceholder: '请输入密码',
  accountAndPasswordRequired: '请输入账号和密码',
  passwordLoginHint: '手机验证码注册的账号，可在设置中开启密码登录',
  passwordSetup: '密码设置',
  oldPasswordPlaceholder: '当前密码',
  newPasswordPlaceholder: '新密码（至少 8 位）',
  passwordMinLength: '密码至少 8 位',
  oldPasswordRequired: '请输入当前密码',
  passwordSaved: '密码已保存',
  newPasswordLabel: '新密码',
  forgotPasswordLink: '忘记密码？',
  resetPasswordTitle: '重置密码',
  resetPasswordAction: '重置密码',
  resetSendHint: '验证码将发送到该手机号，仅限已注册账号',
  passwordResetSuccess: '密码已重置，请使用新密码登录',
  backToLogin: '返回登录',
  passwordSaveAction: '设置密码',
  passwordSaving: '保存密码中...',
  accountSecurity: '账号与安全',
  accountSecurityDesc: '密码修改即时生效，用于手机验证码之外的密码登录',
  loginRequiredDesc: '登录后即可查看该页面内容',
  loginRequired: '请先登录',
  phoneNumberPlaceholder: '11位手机号码',
  autoRegisterHint: '首次登录将自动注册账号',
  codePlaceholder: '6位验证码',
  codeSentTo: '验证码已发送至 {phone}',
  changePhone: '修改手机号',
  resend: '重新发送',
  enterValidPhone: '请输入有效的手机号码',
  enterCode: '请输入验证码',
  usernameRequired: '用户名不能为空',
  usernameMinLength: '用户名至少需要2个字符',
  usernameMaxLength: '用户名不能超过20个字符',
}

export const en = {
  permissionDenied: 'Permission Denied',
  adminOnly: 'This feature is for administrators only',
  welcomeBack: 'Welcome Back',
  verifyIdentity: 'Verify Identity',
  sendCode: 'Send Code',
  canceling: 'Canceling...',
  general: 'General',
  login: 'Login',
  loginTabOtp: 'SMS Code',
  passwordLoginTab: 'Password',
  identifierLabel: 'PHONE / EMAIL',
  identifierPlaceholder: 'Phone number or email',
  passwordPlaceholder: 'Enter your password',
  accountAndPasswordRequired: 'Account and password are required',
  passwordLoginHint: 'Accounts registered via SMS can enable password login in Settings',
  passwordSetup: 'Password',
  oldPasswordPlaceholder: 'Current password',
  newPasswordPlaceholder: 'New password (min 8 characters)',
  passwordMinLength: 'Password must be at least 8 characters',
  newPasswordLabel: 'New Password',
  forgotPasswordLink: 'Forgot password?',
  resetPasswordTitle: 'Reset Password',
  resetPasswordAction: 'Reset Password',
  resetSendHint: 'A code will be sent to this phone number (registered accounts only)',
  passwordResetSuccess: 'Password reset. Please sign in with your new password',
  backToLogin: 'Back to Login',
  passwordSaveAction: 'Set Password',
  passwordSaving: 'Saving password...',
  accountSecurity: 'Account & Security',
  accountSecurityDesc: 'Changes take effect immediately. Used for password login in addition to SMS code',
  loginRequiredDesc: 'Sign in to view this page',
  loginRequired: 'Please sign in first',
  oldPasswordRequired: 'Enter your current password',
  passwordSaved: 'Password saved',
  phoneNumberPlaceholder: '11-digit phone number',
  autoRegisterHint: 'First login automatically registers an account',
  codePlaceholder: '6-digit code',
  codeSentTo: 'Code sent to {phone}',
  changePhone: 'Change number',
  resend: 'Resend',
  enterValidPhone: 'Please enter a valid phone number',
  enterCode: 'Please enter the verification code',
  usernameRequired: 'Username is required',
  usernameMinLength: 'Username must be at least 2 characters',
  usernameMaxLength: 'Username cannot exceed 20 characters',
}

export const ja = {
  permissionDenied: '権限がありません',
  adminOnly: 'この機能は管理者のみ使用可能です',
  welcomeBack: 'おかえりなさい',
  verifyIdentity: '身分を証明',
  sendCode: '認証コードを送信',
  canceling: 'キャンセル中...',
  general: '一般',
  login: 'ログイン',
  loginTabOtp: 'SMS認証',
  passwordLoginTab: 'パスワード',
  identifierLabel: '電話 / メール',
  identifierPlaceholder: '電話番号またはメールアドレス',
  passwordPlaceholder: 'パスワードを入力',
  accountAndPasswordRequired: 'アカウントとパスワードを入力してください',
  passwordLoginHint: 'SMSで登録したアカウントは、設定でパスワードログインを有効化できます',
  passwordSetup: 'パスワード設定',
  oldPasswordPlaceholder: '現在のパスワード',
  newPasswordPlaceholder: '新しいパスワード（8文字以上）',
  passwordMinLength: 'パスワードは8文字以上必要です',
  newPasswordLabel: '新しいパスワード',
  forgotPasswordLink: 'パスワードをお忘れですか？',
  resetPasswordTitle: 'パスワードリセット',
  resetPasswordAction: 'パスワードをリセット',
  resetSendHint: '確認コードをこの電話番号に送信します（登録済みアカウントのみ）',
  passwordResetSuccess: 'パスワードをリセットしました。新しいパスワードでログインしてください',
  backToLogin: 'ログインに戻る',
  passwordSaveAction: 'パスワードを設定',
  passwordSaving: '保存中...',
  accountSecurity: 'アカウントとセキュリティ',
  accountSecurityDesc: '変更は即時反映されます。SMS認証に加えてパスワードログインに使用します',
  loginRequiredDesc: 'ログインするとこのページの内容を表示できます',
  loginRequired: '先にログインしてください',
  oldPasswordRequired: '現在のパスワードを入力してください',
  passwordSaved: 'パスワードを保存しました',
  phoneNumberPlaceholder: '11桁の電話番号',
  autoRegisterHint: '初回ログインで自動的にアカウント登録されます',
  codePlaceholder: '6桁の認証コード',
  codeSentTo: '認証コードを送信しました {phone}',
  changePhone: '電話番号を変更',
  resend: '再送信',
  enterValidPhone: '有効な電話番号を入力してください',
  enterCode: '認証コードを入力してください',
  usernameRequired: 'ユーザー名は必須です',
  usernameMinLength: 'ユーザー名は2文字以上である必要があります',
  usernameMaxLength: 'ユーザー名は20文字を超えることはできません',
}
